<template>
  <div class="edume-chevron">
    <svg
      :class="orientation"
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13 5.7 6.8 3.2 9.2 12 18l8.8-8.8-2.5-2.5-6.3 6.4Z"
        fill="#005c7f"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Chevron',
  props: {
    orientation: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.edume-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
}
.edume-down {
  transform: rotate(180deg);
}
</style>
